import './index.scss';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { pageNavigationRoutes } from '@constants/navigation';
import { Paths } from '@constants/paths';
import { translate } from '@utils';
import { hasPermissionPage } from '@hooks/hasPermissionPage';
import { PagePermission, PermissionActions } from '../../../../api/enums';

const Sidebar = () => {
  const hasManagement = hasPermissionPage([PagePermission.Management], [PermissionActions.View]);
  const hasRoles = hasPermissionPage([PagePermission.Roles], [PermissionActions.View]);

  const routes = [
    {
      name: 'management',
      label: translate('management'),
      path: pageNavigationRoutes.MANAGEMENT,
      isVisible: hasManagement,
    },
    {
      name: 'roles',
      label: translate('roles'),
      path: pageNavigationRoutes.ROLES,
      isVisible: hasRoles,
    },
  ];

  return (
    <div className="sidebar-container" data-testid="sidebar-container">
      <div className="nav-list">
        {routes
          .filter((route) => route.isVisible)
          .map((route) => (
            <NavLink
              key={route.label}
              data-testid={`dashboard-${route.name}`}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              to={`${Paths.DASHBOARD}${route.path}`}
            >
              <div className="nav-item__label">{route.label}</div>
            </NavLink>
          ))}
      </div>
    </div>
  );
};

export { Sidebar };
